/*eslint-disable*/
import { Field } from 'Util/Query';

/**
 * Services Query
 * @class Services
 * @namespace Query/Services
 */

//query{slider:medisouqServices{slides{slide_text,slide_id,mobile_image,desktop_image,title,is_active},slideSpeed:slide_speed,slider_id,title}}
//query{slider:medisouqServices{slides{slide_text,slide_id,mobile_image,desktop_image,title,is_active},slideSpeed:slide_speed,slider_id,title}}
export class ServicesQuery {
    getQuery() {
        
        return new Field('medisouqServices')            
            .addFieldList(this._getServicesFields())
            .setAlias('services');
    }

    _getServicesFields() {
        return [
            this._getServicesField(),        
            'title'
        ];
    }

    _getServiceFields() {
        return [
            'name',
            'price',
            'url',
            'image',          
            'id'
        ];
    }

    _getServicesField() {
        return new Field('services')
            .addFieldList(this._getServiceFields());
    }
}

export default new ServicesQuery();
